<section
  *ngIf="status"
  class="payment-return-page mt-3 text-black dark:!text-white"
  aria-labelledby="payment-title"
>
  <h2 id="payment-title" class="sr-only">Payment status</h2>
  <div #paymentHost class="payment-host"></div>
</section>
